export const SOURCES = "setSources";
export const EXPLORER_LOADED = "explorerLoaded";
export const LOAD_QUERY_INDEX = "loadQueryIndex";
